module.exports = __webpack_public_path__ + "static/media/angel_death.bc57f517.mp3";